function updateInArray(arr, callback, newObj) {
    let index = typeof callback == 'number' ? callback : arr.findIndex(callback);
    if (index !== -1) {
        return [...arr.slice(0, index), newObj, ...arr.slice(index + 1)];
    }
    return arr;
}

function removeInArray(arr, callback) {
    let index = typeof callback == 'number' ? callback : arr.findIndex(callback);
    if (index !== -1) {
        return [...arr.slice(0, index), ...arr.slice(index + 1)];
    }
    return arr;
}

function updateArray(arr, newArr) {
    for (let i = 0; i < newArr.length; ++i) {
        const newObj = newArr[i];
        let index = arr.findIndex((x) => x.filterId === newObj.filterId);
        if (index !== -1) {
            arr[index] = newObj;
        }
    }
    return arr;
}

function mergeArray(arr, property, newArr) {
    for (let i = 0; i < newArr.length; ++i) {
        const newObj = newArr[i];
        if (newObj.hasOwnProperty(property)) {
            arr[i] = newObj;
        }
    }
    return arr;
}

function replaceInArray(arr, index, newObj) {
    return [...arr.slice(0, index), newObj, ...arr.slice(index + 1)];
}

function addInArray(arr, newObj) {
    return [...arr, newObj];
}

function insertInArray(arr, newObj) {
    return [newObj, ...arr];
}

function concatArray(arr, newArr) {
    return [...arr, ...newArr];
}

function insertArray(arr, newArr) {
    return [...newArr, ...arr];
}

function popInArray(arr) {
    return [...arr.slice(0, arr.length - 1)];
}

function shiftInArray(arr) {
    return arr.length ? arr.slice(1) : arr;
}

export {
    updateInArray,
    removeInArray,
    replaceInArray,
    addInArray,
    insertInArray,
    concatArray,
    insertArray,
    popInArray,
    shiftInArray,
    updateArray,
    mergeArray,
};
